import Vue from 'vue'
import { Button,Select,Message} from 'element-ui';
Vue.prototype.$ELEMENT = {
  size: "small",
  zIndex: 3000
};
Vue.use(Button);
Vue.prototype.$message = Message;



// WEBPACK FOOTER //
// ./src/plugins/element.js